$(function () {
    var filter = {};
    var curTags = [];
    var collectionUrl = window['collectionUrl'];
    var sort = "best-selling";
    var updated = false;
    var $applyBtn = $('.filter-btn.apply');
    var waitForApplyBtnBeforeReload = ($applyBtn.length > 0 && $(window).width() < 750) ? true : false;

    // Filter button toggle
    $('.filter-header-btn-container').on('click', function () {
        var $this = $(this).parent();
        
        console.log($this)

        if ($this.hasClass('active')) {
            $this.toggleClass('active');
        } else {
            $('.filter-header-btn-container').parent().removeClass('active');
            $this.toggleClass('active');
        }
    });

    function clearOtherTagsInList(list) {
        list.each(function (i) {
            var d = $(this).data('tag');
            const index = curTags.indexOf(d);
            if (index > -1) {
                curTags.splice(index, 1);
            }
        })
    }

    if (waitForApplyBtnBeforeReload) {
        $applyBtn.on('click', function () {
            fetchMoreProducts();
        });
    }

    $('.selectable-item').on('click', function () {
        /**
         * TODO *
         * ! ON MOBILE ONLY: hide the filter box-overlay
         */

        var $this = $(this),
            category = $this.closest('.dropdown-select-list').data('list'),
            tag = $this.data('tag'),
            btn = $this.closest('.filter-btn');

        btn.find('.selectable-item').removeClass('active');
        btn.addClass('selected');
        btn.parent().addClass('user-selected');
        $this.addClass('active');

        filter[category] = tag;

        // Temp solution
        clearOtherTagsInList(btn.find('.dropdown-select-list li'));

        var lowerCaseTags = curTags.map(string => string.toLowerCase());

        if (!lowerCaseTags.includes(tag.toLowerCase())) {
            curTags.push(tag);
        }

        // Temporary End

        $('.filter-btn.clear').addClass('visible');
        btn.find('.clear').addClass('visible');

        // if ($(window).width() < 750) return updated = true;

        if (!waitForApplyBtnBeforeReload) {
            fetchMoreProducts();
        }
    });

    $('.filter-btn .clear').on('click', function () {
        // CLEAR ONLY WITHIN THIS CATEGORY
        var $this = $(this),
            category = $this.closest('.dropdown-select-list').data('list'),
            btn = $this.closest('.filter-btn');

        btn.removeClass('selected active');
        btn.find('.selectable-item').removeClass('active');
        $this.removeClass('visible');

        // temporarily do this
        clearOtherTagsInList(btn.find('.dropdown-select-list li'));

        // if ($(window).width() < 750) return updated = true;

        return fetchMoreProducts();
        // Temporary End

        delete filter[category];

        // If the filter is now empty - remove global clear button
        if ($.isEmptyObject(filter)) $('.filter-btn.clear').trigger('click');

        if ($(window).width() < 750) return updated = true;

        fetchMoreProducts();
    });

    $('.filter-btn.clear').on('click', function () {
        // CLEAR EVERYTHING
        filter = {};
        curTags = [];
        sort = "";
        window.totalPages = 0;
        $('.selectable-item, .filter-btn, .filter-btn .clear').removeClass('active selected visible');
        $(this).removeClass('visible');

        // if ($(window).width() < 750) return updated = true;

        fetchMoreProducts();
    });

    $('.cp-desktop-sort-by').on('change', function () {
        sort = $(this).val();

        // Always trigger refetch on mobile as well
        updated = true;

        fetchMoreProducts();
    });

    $('.mobile-filter').on('click', function () {
        $('.collection-filter-wrapper').addClass('show-mobile-filter');
        $('body').addClass('filter-open');
    });

    $('.close-btn').on('click', function () {
        $('.collection-filter-wrapper').removeClass('show-mobile-filter');
        $('body').removeClass('filter-open');
        if (updated) fetchMoreProducts(); // Run the fetch query when closing the overlay in case updates have been made
    })

    $(window).resize(function () {
        $('.collection-filter-wrapper').removeClass('show-mobile-filter');
    });

    // Hide options when click outside fliter
    $(document).mouseup(function (e) {
        var container = $('.filter-btn');

        // if the target of the click isn't the container nor a descendant of the container
        if (!container.is(e.target) && container.has(e.target).length === 0) {
            container.removeClass('active');
        }
    });

    // Hide options when hitting ESC key
    $(document).keyup(function (e) {
        if (e.keyCode === 27) $('.filter-btn').removeClass('active');
    });

    function collectionInit() {

        if (window.currentTags) curTags = window.currentTags;
        if (window.sortBy) sort = window.sortBy;

        $.each(curTags, function (e, a) {
            var $this = $('.selectable-item[data-tag="' + a + '"]'),
                btn = $this.closest('.filter-btn');

            btn.addClass('selected');
            $this.addClass('active');

            if ($this) {
                btn.find('.clear').addClass('visible');
                $('.filter-btn.clear').addClass('visible');
            }
        });
    }

    function getParameterByName(name, url) {
        if (!url) url = window.location.href;
        name = name.replace(/[\[\]]/g, '\\$&');
        var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
            results = regex.exec(url);
        if (!results) return null;
        if (!results[2]) return '';
        return decodeURIComponent(results[2].replace(/\+/g, ' '));
    }

    function buildFilterQuery() {

        // Temp solution
        return curTags.length > 0 ? curTags.join('+') : "";
        // Temporary End

        var str = [];
        for (var key in filter) {
            // skip loop if the property is from prototype
            if (!filter.hasOwnProperty(key)) continue;

            str.push(filter[key]);
        }
        return str.length > 0 ? str.join('+') : "";
    }

    function fetchMoreProducts() {
        // This is a precaution, not to execute the update query automatically on mobile, whenever a user is changing the filter values.
        // if ($(window).width() < 750 && !updated) return;

        var currentUrl = window.location.href,
            arr = currentUrl.split("/"),
            domain = arr[0] + "//" + arr[2];

        var newDir = collectionUrl + '/' + buildFilterQuery();
        if (sort) newDir += '?sort_by=' + sort;
        // if (window.totalPages > 1) newDir += '&page=' + window.currentPage;

        window.location.href = newDir;
    }
    collectionInit();
});
